/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios'
import md5 from 'js-md5';
import QS from 'qs'
import {
  Toast
} from 'vant'
import store from '@/store/index'
import Vue from 'vue'
// token刷新Promise缓存
let refreshTokenPromise = null
// baseUrl: 'https://demo.gkgzj.com/api', // 测试环境
// baseUrl: 'https://test.gkgzj.com/api', // 准生产
// baseUrl: 'https://dygk.gkgzj.com/api', // 生产环境
// 环境的切换
if (process.env.NODE_ENV === 'development' && !process.env.VUE_APP_URL) {
  axios.defaults.baseURL = '/'
}  else {
  axios.defaults.baseURL = process.env.VUE_APP_URL // 根据打包脚本自动识别
}

// 请求超时时间
axios.defaults.timeout = 10000

// post请求头
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
// axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'

// 请求拦截器
axios.interceptors.request.use(
  config => {
    // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    // const token = store.state.token
    // token && (config.headers.Authorization = token)
    // 添加感控的请求头
    config.headers['x-userkey'] = ''
    config.headers['x-domain'] = 'A0'
    config.headers.timestamp = new Date().getTime(),
    config.headers.authent = md5('DYMD_GZGZJ_' + new Date().getTime())
    return config
  },
  error => {
    return Promise.error(error)
  })

  let reloginCount = 0

// 响应拦截器
axios.interceptors.response.use(
  response => {
    // console.log(response,'88888');
    if (response.status === 200) {
      if(response.data.status && response.data.status !== 200 ){
        Toast({
          message: response.data.message,
          duration: 1000,
          forbidClick: true
        })
        return  Promise.reject(response)
      }
      return Promise.resolve(response)
    } else {
      return Promise.reject(response)
    }
  },
  // 服务器状态码不是200的情况
  error => {
    if (error.response.status) {
      
      switch (error.response.status) {
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 401:
          // 重新登录
          if(reloginCount < 5) {
            reloginCount++
            console.log(reloginCount);
            // relogin()
          }
          // Toast({
          //   message: '登录失效',
          //   duration: 1500,
          //   forbidClick: true
          // })
          // router.replace({
          //   path: '/login',
          //   query: {
          //     redirect: router.currentRoute.fullPath
          //   }
          // })
          break
          // 403 token过期
          // 登录过期对用户进行提示
          // 清除本地token和清空vuex中token对象
          // 跳转登录页面
        case 403:
           // 重新登录
           relogin()
          // Toast({
          //   message: '登录过期，请重新登录',
          //   duration: 1000,
          //   forbidClick: true
          // })
          // // 清除token
          // localStorage.removeItem('token')
          // store.commit('loginSuccess', null)
          // // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
          // setTimeout(() => {
          //   router.replace({
          //     path: '/login',
          //     query: {
          //       redirect: router.currentRoute.fullPath
          //     }
          //   })
          // }, 1000)
          break
          // 404请求不存在
        case 404:
          Toast({
            message: '网络请求不存在',
            duration: 1500,
            forbidClick: true
          })
          break
          // 其他错误，直接抛出错误提示
        default:
          Toast({
            message: error.response.data.message,
            duration: 1500,
            forbidClick: true
          })
      }
      return Promise.reject(error.response)
    }
  }
)

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
        params: params
      })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @param {Object} qs [是否是获取token的接口]
 */
export function post(url, params, qs = false) {
  return new Promise((resolve, reject) => {
    if (qs) {
      params = QS.stringify(params)
    }
    let headers = packageHeaders(qs)
    setTimeout(() => {
      store.commit('showLoading')
    }, 10)
    axios.post(url, params, headers)
      .then(res => {
        resolve(res.data)
        setTimeout(() => {
          store.commit('hideLoading')
        }, 50)

      })
      .catch(err => {
        if (err.status === 401) {
          console.log('检测到token过期401错误')
          
          // 如果没有正在进行的刷新，创建新的刷新Promise
          if (!refreshTokenPromise) {
            console.log('开始刷新token')
            refreshTokenPromise = store.dispatch('getAccessToken')
              .then(tokenData => {
                console.log(tokenData, 'token刷新成功')
                refreshTokenPromise = null // 清除缓存
                return tokenData
              })
              .catch(tokenErr => {
                console.log('token刷新失败')
                refreshTokenPromise = null // 清除缓存
                throw tokenErr
              })
          } else {
            console.log('token正在刷新中，等待刷新完成')
          }
          
          // 等待token刷新完成后重试
          refreshTokenPromise
            .then(() => {
              let retryHeaders = packageHeaders(qs)
              return axios.post(url, params, retryHeaders)
            })
            .then(res => {
              resolve(res.data)
              setTimeout(() => {
                store.commit('hideLoading')
              }, 50)
            })
            .catch(retryErr => {
              reject(retryErr.data)
              setTimeout(() => {
                store.commit('hideLoading')
              }, 50)
            })
        } else {
          reject(err.data)
          setTimeout(() => {
            store.commit('hideLoading')
          }, 50)
        }
      })
  })
}

// 打包请求头
function packageHeaders(qs = false) {
  // console.log(store.state.access_token, 'token,,,,');
  let headers = {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Authorization': 'Bearer ' + store.state.access_token
    }
  }
  if (qs) {
    headers = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': store.state.token
      }
    }
  }
  return headers
}

// 重新获取登录token
function relogin() {
  console.log('重新登录');
  let params = {
    grant_type: 'client_credentials'
  }
  Vue.prototype.$http.token(params)
    .then(res => {
       store.commit('vModelAccessToken',res)
       setTimeout(()=>{
         location.reload()
       },80)
    })
}
